// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__TKXJs","requiredAsterisk":"Info_requiredAsterisk__z4_rc"};